/**
 * Device category for Amplitude's `client_device` property.
 *
 * Ported from signup (`src/utils/amplitudeEvents.ts`), which owns the only other
 * copy: the helper is not exported from `@iwoca/frontend-tracking-library`, and
 * `client_device` already feeds Looker explores, so the three values have to
 * match signup's exactly.
 *
 * Reads the user agent, never the viewport — despite what the property's
 * description in the Amplitude tracking plan says. A narrow desktop window is
 * still `Desktop`.
 */
export const getAmplitudeDeviceCategory = ():
  | 'Mobile'
  | 'Tablet'
  | 'Desktop' => {
  const ua = navigator.userAgent;

  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'Tablet';
  }

  if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua,
    )
  ) {
    return 'Mobile';
  }

  return 'Desktop';
};
